// extracted by mini-css-extract-plugin
module.exports = {"popup":"_3Cb60YJysZdRhQ9cT9oLAp","form":"_2AbG7o9eJcTZRoi3jU7PgD"};